import React, { useState } from "react";
import { Link } from "react-router-dom";
import { handleNewsletter } from "./../../api/newsletter";
import { newsletterSchema } from "./../../components/common/forms/validation-schema";
import { useFormik } from "formik";
import ErrorMsg, {
  ErrorApiMsg,
  SuccessApiMsg,
} from "./../../components/common/forms/error-msg";
import Modal from "react-modal";

const social_links = ["social_facebook", "social_twitter", "social_youtube"];

const footer_widget = [
  {
    col: "col-xxl-3 offset-xxl-1 col-xl-2 offset-xl-1 col-lg-4 offset-lg-0 col-md-2 offset-md-1 col-sm-5 offset-sm-1",
    title: "Plataforma",
    footer__link: ["Principal", "Cursos", "Conheça a Pri"],
  },
];

const Footer = ({ gray_bg, pt = "pt-190" }) => {
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "500px",
      height: "400px",
    },
    overlay: { zIndex: 1000 },
  };

  const [apiErrors, setApiErrors] = useState(null);
  const [apiSuccess, setApiSuccess] = useState(null);
  const [isSubmting, setIsSubmiting] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOnSubmit = (values, { resetForm }) => {
    if (isSubmting == false) {
      setIsSubmiting(true);

      handleNewsletter({
        email: values.email,
        nome: "",
        origem: "newletter rodape",
      }).then((res) => {
        if (res.cd_newsletter) {
          setApiSuccess("Registrado com sucesso!");
        }

        setIsSubmiting(false);
        resetForm();
      });
    }
  };

  // use formik
  const { handleChange, handleSubmit, handleBlur, errors, values, touched } =
    useFormik({
      initialValues: { email: "" },
      validationSchema: newsletterSchema,
      onSubmit: handleOnSubmit,
    });

  return (
    <>
      <footer>
        <Modal
          isOpen={isModalOpen}
          onRequestClose={() => setIsModalOpen(false)}
          style={customStyles}
        >
          <a onClick={() => setIsModalOpen(false)} style={{ float: "right" }}>
            <i className="icon_close"></i>{" "}
          </a>
          <h3 style={{ marginTop: "30px" }}>
            Termos de Uso - Atualizado em agosto de 2019
          </h3>
          <p>
            <strong>Atualizado em 22 de Agosto de 2019.</strong>
          </p>
          <p>
            Bem-vindo ao profaprizattera.com.br. A Profa. Pri Záttera apresenta
            os Termos de Uso (“Termos de Uso”) de seu website
            (https://www.profaprizattera.com.br), sua plataforma e seus serviços
            (juntos, a “Plataforma”) estabelecidos neste documento. O CNPJ da
            empresa Profa Pri Záttera é 32.248.612/0001-94.
          </p>
          <p>
            Reservamo-nos o direito de alterar ou modificar estes Termos de Uso
            ao nosso exclusivo critério, a qualquer momento.Qualquer alteração
            ou modificação a estes Termos de Uso entrará em vigor imediatamente
            após a publicação em nosso website. Você é responsável por analisar
            periodicamente a mais atualizada versão destes Termos de Uso.
          </p>
          <p>
            Os Termos de Uso e a Política de Privacidade são válidos para todos
            os usuários da nossa Plataforma.
          </p>
          <p>
            O uso continuado dos nossos serviços constitui a aceitação de
            quaisquer alterações ou modificações feitas nos Termos de Uso.
            Lembre-se:{" "}
          </p>
          <p>
            - Você e só você e responsável por sua senha e será responsável por
            qualquer dano resultante da não manutenção da sua confidencialidade.
          </p>
          <br />
          <p>
            - São permitidos Membros com pelo menos 13 anos de idade. Segundo o
            Art. 932, incisos I e IV, do Código Civil, os pais e a escola são
            responsáveis pelos atos das crianças, inclusive no ambiente digital.
          </p>
          <br />
          <p>
            - Não é permitido o acesso simultâneo em dois computadores
            diferentes, caso isso ocorra você será desligado do site
            profaprizattera.com.br e nenhum valor será restituído. Será
            necessário um novo cadastro e pagamento para voltar a acessar o
            site.
          </p>
          <br />
          <p>
            - O site profaprizattera oferece apenas o acesso às videoaulas,
            materiais, imagens e tudo que se encontra dentro dele. Assim, o
            conteúdo em si não é vendido, apenas é permitido seu acesso por um
            tempo limitado.
          </p>
          <p>
            - Não é permitida a cópia, reprodução para terceiros, venda, revenda
            ou exploração com fins comerciais do conteúdo contido em
            profaprizattera.com.br.
          </p>
          <p>
            - Todos esses termos em destaque se encontram neste termo de uso.
          </p>
          <p>
            <strong>1. Aceitação aos Termos de Uso</strong>
          </p>
          <p>
            1.1 Ao acessar e/ou usar os serviços do profaprizattera.com.br,
            aulas pré-gravadas, aulas ao vivo, monitorias online e demais
            serviços oferecidos em nosso website (“Serviços”), você concorda com
            os Termos de Uso, suas cláusulas e condições, conforme abaixo
            detalhadas.
          </p>
          <p>
            1.2 Você está autorizado a utilizar os Serviços do
            profaprizattera.com.br somente se você concorda com todas regras e
            condições estabelecidas nos Termos de Uso.
          </p>
          <p>
            1.3 Se você não concorda com esses Termos de Uso, você não está
            autorizado a acessar ou utilizar os Serviços oferecidos em nosso
            website. A utilização dos Serviços profaprizattera.com.br está
            expressamente condicionada ao seu consentimento às regras dos Termos
            de Uso.
          </p>
          <p>2. Usuários e Membros:</p>
          <p>
            2.1 Usuários: O uso das áreas públicas do profaprizattera.com.br
            está disponível para qualquer pessoa, sem necessidade de registro.
            Para poder usufruir dos serviços privados, reservados aos Membros, o
            usuário deve se registrar para se tornar um Membro do
            profaprizattera.com.br. A palavra “Usuário” se referirá a qualquer
            usuário que não tenha se registrado como Membro do
            profaprizattera.com.br.
          </p>
          <p>
            2.2 Membros: Qualquer pessoa com pelo menos 13 anos de idade,
            residente em qualquer parte do mundo, pode se tornar Membro do
            profaprizattera.com.br. A palavra “Membro” se referirá a qualquer
            pessoa que tenha se registrado em nosso website. Membros menores de
            12 anos não são permitidos no website tomando como base o Sistema de
            classificação indicativa Brasileira. Segundo o Art. 932, incisos I e
            IV, do Código Civil, os pais e a escola são responsáveis pelos atos
            das crianças, inclusive no ambiente digital.
          </p>
          <p>
            2.3 Senha e Segurança: Quando você completar o seu processo de
            registro, você criará uma senha que habilitará seu acesso à nossa
            Plataforma. Você concorda em manter a confidencialidade da sua senha
            e é inteiramente responsável por qualquer dano resultante da não
            manutenção dessa confidencialidade e de todas as atividades que
            ocorrerem por meio do uso de sua senha. Você concorda em nos
            notificar imediatamente de qualquer acesso não autorizado de sua
            senha ou outra quebra de segurança. Você concorda que o
            profaprizattera.com.br não será responsabilizado por qualquer perda
            ou dano que ocorra a partir do não cumprimento desta cláusula.
          </p>
          <p>
            <strong>3. Informações Públicas e Privadas:</strong>
          </p>
          <p>
            3.1 “Suas Informações”: são definidas como qualquer informação
            postada por você ou que você nos dê (direta ou indiretamente),
            inclusive por meio do seu processo de registro ou do seu uso de
            nossa Plataforma, comentários em blogs, mensagens enviadas dentro de
            nossa Plataforma, ou e-mail. Você é o único responsável por Suas
            Informações, e nós agimos como um canal passivo para a distribuição
            e publicação de suas Informações Públicas (como definidas abaixo).
          </p>
          <p>
            3.2 “Informações Públicas”: seu nome, afiliação a companhias e
            localidade, bem como qualquer parte de Suas Informações que, por
            meio do uso de nossa Plataforma ou de outra maneira, você envie ou
            disponibilize para a inclusão em áreas públicas de nosso website.
          </p>
          <p>
            3.3 “Informação Privada”: qualquer outra parte de Suas Informações
            que não sejam Informações Públicas será referida como Informação
            Privada.
          </p>
          <p>
            3.4 “Áreas públicas”: são aquelas áreas do nosso website que são
            acessíveis para alguns ou todos os nossos Membros (p.ex., não
            restritas à sua visualização apenas) ou para o público geral.
          </p>
          <p>
            3.5 Acessibilidade das Informações Públicas: As suas Informações
            Públicas podem ser acessíveis e publicadas por programas de
            publicação automática e por ferramentas de busca, ferramentas de
            metabusca, crawlers, metacrawlers e outros similares.
          </p>
          <p>3.6 Restrições:</p>
          <p>
            Ao considerar o uso de nossa Plataforma, você concorda que as Suas
            Informações: (a) não devem ser fraudulentas; (b) não devem infringir
            nenhum direito autoral de terceiros, patente, marca registrada,
            direito de distribuição ou outro direito de propriedade intelectual,
            de publicação ou privacidade; (c) não devem violar nenhuma lei,
            estatuto, ordenação ou regulamento; (d) não devem ser difamatórias,
            caluniosas, ameaçadoras ou abusivas; (e) não devem ser obscenas ou
            conter pornografia, pornografia infantil, ou fotos de pessoas
            despidas; (f) não devem conter vírus, cavalos de troia, worms, time
            bombs, cancelbots, easter eggs ou outras rotinas de programação que
            possam danificar, interferir, interceptar ou desapropriar qualquer
            sistema, dado ou informação pessoal; (g) não devem nos
            responsabilizar ou fazer com que percamos (total ou parcialmente) o
            serviço do nosso Provedor de Internet ou outros fornecedores; (h)
            não devem criar links direta ou indiretamente a qualquer material
            que você não tenha direito de incluir ou linkar.
          </p>
          <p>
            3.7 Obrigações: Você concorda também que deverá nos informar um
            endereço válido de e-mail, tanto na hora de seu registro conosco
            quanto a cada vez que o seu e-mail mudar. Você concorda também que o
            seu perfil de Membro, a Newsletter do profaprizattera.com.br,
            postagens de comentários em blogs, uploads de fotos ou quaisquer
            porções do website reservadas apenas a uso dos Membros não devem ser
            usadas por você para atividades comerciais, vendas de bens e
            serviços, ou a promoção de uma companhia, bem ou serviço não
            relacionado ao tópico ou espírito do profaprizattera.com.br ou de
            Grupo de Membros em particular. Você será exclusivamente responsável
            pelas informações que você postar nas áreas publicamente acessíveis
            da Plataforma, independente de sua intenção ou não de fazê-lo.
          </p>
          <p>
            3.8 Privacidade: Todas as informações pessoais relacionadas ao uso
            dos Serviços ou ao uso do website profaprizattera.com.br estão
            sujeitas à nossa Política de Privacidade.
          </p>
          <p>
            3.9 Licença. Nós não clamamos propriedade de Suas Informações. Nós
            usaremos as suas Informações Pessoais Identificáveis apenas de
            acordo com a nossa Política de Privacidade. Entretanto, para nos
            autorizar a usar suas Informações Públicas e para nos assegurar de
            que não violamos nenhum direito que você possa ter sobre suas
            Informações Públicas, você garante ao profaprizattera.com.br o
            direito não exclusivo, universal, sem pagamento de royalties, em
            caráter total, definitivo, irrevogável e irretratável, de utilizar,
            a qualquer tempo, no Brasil e/ou no exterior e de exercer,
            comercializar e explorar todos os direitos de cópia, publicidade, e
            direitos de base de dados que você possua sobre suas Informações
            Públicas, por meio de qualquer meio conhecido ou que venha a ser
            criado futuramente, e para qualquer fim.
          </p>
          <p>
            3.10 Restrições no Nosso Uso de Suas Informações. Exceto se
            especificado contrariamente em nossa Política de Privacidade, nós
            não venderemos, alugaremos ou divulgaremos nenhuma parte de suas
            Informações Pessoais Identificáveis (como definidas em nossa
            Política de Privacidade) sobre você (incluindo seu endereço de
            e-mail) para terceiros.
          </p>
          <p>
            3.11 Consentimento de Divulgação. Você entende e concorda que o
            profaprizattera.com.br pode divulgar Suas Informações se requerida a
            fazê-lo por lei ou por acreditar de boa fé que essa divulgação é
            razoável e necessária para: (a) cooperar com um procedimento
            judicial, uma ordem judicial ou processo legal sobre nós ou nosso
            website; (b) reforçar os Termos de Uso; (c) replicar a respeito da
            infração do direito de terceiros por Suas Informações; (d) proteger
            os direitos, propriedades ou a segurança pessoal do
            profaprizattera.com.br, seus empregados, usuários e público.
          </p>
          <p>
            3.12 Consentimento de divulgação: O profaprizattera.com.br
            reserva-se o direito, a seu exclusivo critério, de suspender ou
            terminar o seu uso de nossa Plataforma e de nossos Serviços, de
            recusar todo e qualquer uso corrente ou futuro de todas ou algumas
            partes de nossa Plataforma e/ou Serviços.
          </p>
          <p>
            <strong>4. Condições gerais de uso dos Serviços</strong>
          </p>
          <p>
            4.1 Ao aceitar estes Termos de Uso, você tem o direito não
            exclusivo, intransferível, não sublicenciável e limitado de entrar,
            acessar e usar os Serviços, unicamente para uso pessoal e não
            comercial.
          </p>
          <p></p>
          <p>
            4.2 Todos os direitos não previstos expressamente nestes Termos de
            Uso estão reservados ao profaprizattera.com.br.
          </p>
          <p>
            4.3. Você concorda que os Serviços são para o seu uso pessoal e não
            comercial e que ninguém além de você usará os Serviços. Você não tem
            direitos de cópia ou reprodução no todo ou em parte, de qualquer
            parte dos Serviços de propriedade do profaprizattera.com.br.
          </p>
          <p>
            4.4 Além da licença limitada de uso estabelecida nestes Termos de
            Uso, você não tem qualquer outro direito, título ou propriedade
            sobre os Serviços ou conteúdos dentro da plataforma. Você entende e
            reconhece que, em quaisquer circunstâncias, os seus direitos com
            relação aos Serviços serão limitados pelos direitos autorais e/ou
            leis de propriedade intelectual aplicáveis e ainda por estes Termos
            de Uso.
          </p>
          <p>
            4.5 Os Serviços permitem que os Membros se conectem com professores
            contratados independentes (os "Professores"), que fornecem
            instruções ao vivo e/ou gravadas, tutoria e serviços de aprendizagem
            nas salas de aula on-line (o "Conteúdo"). O Conteúdo inclui, sem
            limitação, aulas pré-gravadas, aulas ao vivo, monitorias online e
            demais Serviços oferecidos em nosso website, materiais de apoio,
            podendo conter interação e feedback com os Membros.
          </p>
          <p>
            4.6 O profaprizattera.com.br poderá modificar os Serviços e/ou
            Conteúdo ou descontinuar a sua disponibilidade a qualquer momento.
          </p>
          <p>
            4.7 Você é o único responsável pela obtenção, pagamento e manutenção
            de todos os serviços de telefonia, acesso à internet, plano de
            dados, tarifas e/ou outras taxas, mensalidades e custos associados
            ao seu acesso e uso dos Serviços, bem como pelo software, hardware
            de computador e outros equipamentos necessários para o uso e acesso
            aos Serviços.
          </p>
          <p>
            4.8. Não obstante outras disposições contidas nestes Termos de Uso,
            os Serviços estão disponíveis para seu uso por um período que começa
            a partir do registro de seus dados junto com o pagamento
            correspondente ao plano escolhido, incluindo as suas renovações.
          </p>
          <p>
            4.10. Você não deve tentar nem apoiar as tentativas de terceiros
            para driblar, reverter a engenharia, decodificar, decompilar,
            desmontar ou fraudar ou interferir de qualquer forma com aspectos
            dos Serviços. Você não deve distribuir, intercambiar, modificar,
            vender ou revender ou retransmitir a qualquer pessoa qualquer parte
            dos Serviços, incluindo, mas não se limitando, a qualquer texto,
            imagem ou áudio, para qualquer finalidade empresarial comercial ou
            pública. Você concorda em não copiar, vender, distribuir ou
            transferir o Conteúdo e/ou Serviços profaprizattera.com.br.
          </p>
          <p>
            <strong>5. Pagamento.</strong>
          </p>
          <p>
            5.1 Você concorda em efetuar o pagamento pelo Plano de Serviços
            contratado que não seja disponibilizado de forma gratuita pelo
            profaprizattera.com.br.
          </p>
          <p>
            5.2 Você deverá fornecer, manter e atualizar informações
            verdadeiras, exatas, atuais e completas sobre si mesmo conforme for
            solicitado por nossos processos de registro (os “Dados de
            Registro”). Você não poderá se passar por outra pessoa física ou
            jurídica ou adulterar sua identidade ou sua afiliação a qualquer
            pessoa física ou jurídica, incluindo o uso do nome de usuário, senha
            ou de outra informação de conta de outra pessoa física ou jurídica
            ou o nome, a semelhança, voz, imagem ou fotografia de outra pessoa.
            Você não deverá fornecer detalhes falsos sobre você, sobre um dos
            seus pais ou responsáveis.
          </p>
          <p>
            5.3 Transações bancárias por meio de cartão de crédito. Durante sua
            inscrição, as informações do seu cartão de crédito ou de sua conta
            bancária podem ser solicitadas. Como Membro, você concorda que sejam
            cobrados no seu cartão de crédito ou debitados na sua conta
            bancária, ou ainda através de boleto bancário, os preços relativos
            aos planos e todas as taxas e impostos sobre vendas e quaisquer
            outras despesas aplicáveis ao uso dos Serviços.
          </p>
          <p>
            5.4 Direito de alterar os preços. O profaprizattera.com.br
            reserva-se o direito de alterar os preços publicados no website a
            qualquer momento, sem aviso prévio.
          </p>
          <p>
            5.5 Política de reembolso. Em até 7 (sete) dias após a compra do
            plano de serviços, em caso de desistência da contratação, você pode
            solicitar o cancelamento. Neste caso, o reembolso será realizado
            pelo Pag Seguro por meio de estorno no cartão de crédito no qual a
            compra foi efetuada, em até 60 (sessenta) dias após a solicitação.
            Nenhum pagamento será reembolsável quando solicitado após 7 (sete)
            dias da data de compra do plano de serviços. No caso de pagamentos
            via boleto bancário, os reembolsos serão realizados através de
            depósito em conta corrente do Membro dentro do prazo de 60
            (sessenta) dias após a solicitação.
          </p>
          <p>
            5.6 Exceto disposição em contrário nestes Termos de Uso, nenhuma
            mensalidade, taxa ou despesa será reembolsável.
          </p>
          <p>
            <strong>6. Uso da Plataforma</strong>
          </p>
          <p>
            6.1 Responsabilidade e Controle. Você, e não o
            profaprizattera.com.br, é inteiramente responsável por Suas
            Informações que faça upload, poste, distribua, envie por e-mail ou
            de alguma outra forma torne disponível via nossa Plataforma. Nós não
            controlamos suas Informações Públicas ou as Informações Públicas de
            outros Membros ou postadas por eles, e não garantimos a precisão,
            integridade ou a qualidade de Suas Informações ou das Informações
            postadas por ou sobre outros Membros, nem endossamos nenhuma opinião
            expressada por você ou por outros Membros. Você entende que usando
            nossa Plataforma, você pode ser exposto a informações ofensivas,
            indecentes ou com as quais não concorde. Nós não temos nenhuma
            obrigação de monitorar, nem tomamos qualquer responsabilidade pelas
            Suas Informações, pelas Informações Públicas ou informações a
            respeito de quaisquer assuntos ou postadas por outros Usuários. Você
            concorda que sob nenhuma circunstância o profaprizattera.com.br,
            seus diretores, sócios ou funcionários poderão ser responsabilizados
            por quaisquer informações, incluindo, mas não se limitando a erros
            ou omissões nas Suas Informações ou nas Informações Públicas
            postadas por ou sobre outros Membros, por perdas e danos de qualquer
            tipo, ocorridas como resultado do uso das Suas Informações ou de
            quaisquer Informações Públicas de ou sobre outros Membros que venham
            a ser postadas, enviadas por e-mail, transmitidas ou
            disponibilizadas de qualquer outra maneira conectada à nossa
            Plataforma, ou por qualquer falha em corrigir ou remover quaisquer
            dessas informações.
          </p>
          <p>6.2 Condições para Suspensão ou Término dos Serviços.</p>
          <p>
            6.2.1 Os seguintes tipos de ação são vedados no website e na
            Plataforma profaprizattera.com.br e são passíveis de suspensão e/ou
            término imediato do seu status de Membro:
          </p>
          (a) Uso de nossa Plataforma para: (i) ameaçar ou intimidar outra
          pessoa de qualquer forma, incluindo a restrição ou inibição do uso de
          nossa Plataforma; (ii) personificar qualquer pessoa (incluindo a
          equipe do profaprizattera.com.br ou outros Membros), ou atestar
          falsamente afiliação ou representação de qualquer pessoa ou companhia,
          através do uso de endereços de e-mail similares, apelidos, ou a
          criação de contas falsas ou qualquer outro método ou procedimento;
          (iii) disfarçar a origem de quaisquer Informações Públicas que sejam
          transmitidas a terceiros; (iv) perseguir ou perturbar outrem; (v)
          coletar ou armazenar dados pessoais de outros usuários;<p></p>
          (b) Postar quaisquer Informações Públicas ou outro material: (i) que
          seja ilegal, ofensivo, racista, preconceituoso, ameaçador, abusivo,
          perturbador, difamatório, intimidador, vulgar, obsceno, profano,
          acusatório, que invada a privacidade de outrem (inclusive a postagem
          de e-mails privados ou informações de contato de outros usuários),
          odioso, racial, eticamente ou de qualquer outra forma contestável,
          incluindo quaisquer Informações Públicas ou outro material que possa
          ser considerado um discurso de ódio; (ii) que seja obsceno,
          pornográfico ou adulto por natureza; (iii) que você não tenha o
          direito de disponibilizar por qualquer lei ou por contrato; (iv) que
          infrinja qualquer patente, marca registrada, segredo comercial,
          direitos autorais ou quaisquer outros direitos de propriedade
          intelectual ou direitos de terceiros; (v) que seja qualquer tipo de
          propaganda ou material promocional não solicitado, ou qualquer outra
          forma de solicitação (incluindo, mas não se limitando a “spam”, “junk
          mail”, e correntes de e-mail); ou (vi) que seja de qualquer outra
          forma inapropriado ou postado de má fé;<p></p>
          <p>
            (c) Encorajar outrem a violar os Termos de Uso ou se recusar a
            seguir instruções da equipe do profaprizattera.com.br;
          </p>
          <p>
            (e) Violar (intencional ou não intencionalmente) os Termos de Uso,
            ou de qualquer lei, ordenação, estatuto ou regulamento local,
            estadual, nacional ou internacional aplicável.
          </p>
          <p>
            (f) Compartilhamento de Contas. Você e só você e responsável por sua
            senha e será responsável por qualquer dano resultante da não
            manutenção da confidencialidade da mesma.
          </p>
          <p>
            (g) Exceder o limite de maquina e ip's concedido para acesso. Cada
            assinatura dá o direito ao cadastro de 3 máquinas e 2 ip's.
            Entende-se por maquinas: computadores, notebooks, tablets ou
            smartphones.
          </p>
          6.2.2 Mesmo que nós proibamos o conteúdo e as condutas acima, você
          entende e concorda que você poderá vir a ser exposto a tais condutas e
          conteúdos e que usa a Plataforma a seu próprio risco. Para os
          propósitos destes Termos de Uso, “postar” inclui o upload, a postagem,
          distribuição, envio de e-mails, publicação, transmissão ou
          disponibilização de alguma outra forma.<p></p>
          <p>
            6.2.3 Sem se limitar aos ao disposto acima, o profaprizattera.com.br
            tem o direito de remover quaisquer Informações Públicas ou outro
            material que viole esses Termos de Uso ou seja de outra maneira
            questionável.
          </p>
          <p>
            6.3 Não-Interferência com a Plataforma. Você concorda que não irá:
            (a) fazer upload, postar, publicar, distribuir, enviar por e-mail ou
            transmitir de qualquer outra forma rotinas de programação, arquivos
            ou programas com a intenção de interromper, destruir ou limitar as
            funcionalidades de qualquer software ou hardware ou equipamento de
            telecomunicação; (b) interferir com ou perturbar nossa Plataforma ou
            com as redes conectadas ao nosso website através do uso de nossa
            Plataforma, ou desobedecer quaisquer requerimentos, procedimentos,
            políticas ou regulamentos das redes conectadas ao nosso website, ou
            de alguma outra maneira interferir com a nossa Plataforma em
            qualquer sentido, incluindo através do uso de JavaScript, ou outros
            códigos; (c) agir de qualquer maneira que imponha uma carga
            excessivamente pesada, que seja desproporcional ou não razoável, em
            nossa infraestrutura; (d) copiar, reproduzir, alterar, modificar ou
            exibir publicamente qualquer informação que esteja disponível em
            nosso website (exceto as Suas Informações), ou criar trabalhos
            derivados do nosso website (exceto Suas Informações), com o
            entendimento de que tais ações constituiriam infração de direitos
            autorais ou outro tipo de violação à propriedade intelectual e/ou
            industrial do profaprizattera.com.br ou de quaisquer terceiros,
            exceto se autorizado por escrito e com antecedência pelo
            profaprizattera.com.br ou pelo terceiro.
          </p>
          <p>
            6.4 Práticas Gerais de Uso da Plataforma. Você declara saber e
            entender que nós podemos estabelecer práticas e limites gerais no
            que diz respeito ao uso de nossa Plataforma. Você concorda que nós
            não nos responsabilizamos nem podemos ser responsabilizados pelo
            armazenamento ou apagamento, ou pela falha em armazenar ou apagar,
            qualquer uma de Suas Informações. Você entende que nós nos
            reservamos o direito de suspender Membros que estejam inativos por
            um período extenso de tempo. Você entende que nós nos reservamos o
            direito de mudar essas práticas e limites gerais a qualquer momento,
            a nosso critério, com ou sem aviso.
          </p>
          <p>
            <strong>7. Comunicados da Equipe Profa. Pri Záttera</strong>
          </p>
          <p>
            7.1 Você entende e concorda que nós podemos enviar certos
            comunicados, como anúncios de serviços do profaprizattera.com.br e
            newsletters, bem como ofertas de bens e serviços relevantes e que
            beneficiem você ou qualquer grupo de Membros unidos por afinidade
            que você possa vir a participar, e que esses comunicados são
            considerados parte de nossa Plataforma.
          </p>
          <p>
            <strong>8. Links</strong>
          </p>
          <p>
            8.1 Nós podemos providenciar, ou terceiros podem providenciar e
            publicar, links para outros websites ou recursos. Por não termos
            controle sobre tais websites ou recursos, você entende e concorda
            que nós não somos responsáveis pela disponibilidade de tais websites
            e recursos, e nós não endossamos e não nos responsabilizamos nem
            somos passíveis de ser responsabilizados por qualquer conteúdo,
            publicidade, produto, ou outro material disponível neste ou através
            deste website ou recurso.
          </p>
          <p>
            8.2 Você também entende e concorda que o profaprizattera.com.br não
            será responsável nem poderá ser responsabilizado, direta ou
            indiretamente, por quaisquer perdas e danos causadas ou alegadas de
            terem sido causadas ou relacionadas ao uso de qualquer conteúdo, bem
            ou serviço disponível na Plataforma ou através do uso de qualquer um
            desses websites, recursos e/ou serviços.
          </p>
          <p>
            <strong>9. Garantias e Responsabilidades</strong>
          </p>
          <p>
            9.1 Isenção de Garantias. Você usa a nossa Plataforma a seu próprio
            e exclusivo risco. Nossa Plataforma é oferecida a você “como é” e
            “como está disponível”. Nós nos isentamos de garantias e condições
            de qualquer tipo, sejam expressas, implícitas ou instituídas,
            incluindo mas não se limitando a garantias relacionadas à segurança,
            confiabilidade, conveniência e performance de nossa Plataforma. Nós
            nos isentamos ainda de quaisquer garantias sobre informações ou
            conselhos obtidos através de nossa Plataforma. Isentamo-nos de
            quaisquer garantias de terceiros por serviços ou bens recebidos
            através ou anunciados em nossa Plataforma ou recebidos através de
            links exibidos em nossa Plataforma, bem como por qualquer informação
            ou conselho recebido através de quaisquer links exibidos em nossa
            Plataforma. Além disso, nenhum conselho ou informação, seja oral ou
            escrita, obtida de você por nós, deve criar nenhum tipo de garantia.
          </p>
          <p>
            9.2 Suposição de Risco. Você entende e concorda que ao fazer
            download ou obter qualquer outra forma de acesso ao nosso material
            ou dados através do uso de nossa Plataforma ao seu próprio critério
            e risco e que você será o único responsável por quaisquer danos ao
            seu computador ou perda de dados que resulte do download deste
            material ou dados.
          </p>
          <p>
            9.3 Limitação de Responsabilidade. Você concorda que, em nenhuma
            circunstância, o profaprizattera.com.br poderá ser responsabilizado
            por qualquer dano direto, indireto, incidental, especial,
            consequencial ou punitivo, incluindo mas não se limitando a perdas e
            danos, lucros cessantes, perda de uma chance, outras perdas e danos
            intangíveis (ainda que o profaprizattera.com.br tenha sido alertado
            sobre a possibilidade de ocorrência de tais danos), relacionado ao
            uso dos Serviços ou de nossa Plataforma, nem com relação à
            incapacidade e/ou impossibilidade de usá-los (incluindo hipóteses de
            negligência).
          </p>
          <p>
            <strong>10. Indenização</strong>
          </p>
          <p>
            10.1 Você concorda em defender, indenizar e proteger a
            profaprizattera.com.br, seus diretores, sócios, agentes,
            funcionários, consultores, afiliados, subsidiários e parceiros
            contra toda e qualquer reclamação, perda, dano, responsabilização,
            julgamento, avaliação, multa, custo e outras despesas, incluindo
            honorários advocatícios, resultantes ou relacionados ao uso feito
            por você dos Serviços ou de qualquer violação dos Termos de Uso, uso
            da Plataforma, Suas Informações, violação de qualquer lei, estatuto,
            ordem ou regulamento ou direitos de terceiros e concorda em
            reembolsar o profaprizattera.com.br por quaisquer perdas, custos e
            despesas em que ela incorra por consequência disso.
          </p>
          <p>
            <strong>11. Rescisão</strong>
          </p>
          <p>
            11.1 Você concorda que nós, ao nosso critério, podemos disparar um
            alerta, suspender temporariamente, indefinidamente ou remover
            completamente qualquer conteúdo ou informação postada por você, ou
            encerrar com o seu status de Membro ou com a sua capacidade de uso
            total ou parcial de nossa Plataforma, por qualquer razão, incluindo
            mas não se limitando a (a) por falta de uso; (b) se nós acreditarmos
            que você violou ou agiu de forma inconsistente com o espírito destes
            Termos de Uso ou dos documentos incorporados como referência; (c) se
            não formos capazes de verificar ou autenticar qualquer informação
            que você nos forneça; (d) se acreditarmos que suas ações possam
            gerar responsabilidade civil a você, aos nossos usuários ou a nós.
            11.2 Você declara-se ciente de que o encerramento da sua conta ou do
            acesso total ou parcial à Plataforma por motivo esclarecido nesses
            Termos de Uso poderá ser efetuado sem aviso prévio, e entende e
            concorda que poderemos imediatamente desativar ou apagar a sua conta
            e todas as informações e arquivos relativos a ela e/ou barrar seu
            acesso futuro à nossa Plataforma. Você também concorda que nós não
            podemos ser responsabilizados por você ou por terceiros pelo
            encerramento do seu uso de todas ou quaisquer partes da Plataforma.
          </p>
          <p>
            11.3 O profaprizattera.com.br reserva-se o direito de rescindir o
            seu plano de Serviços e/ou o seu acesso aos Serviços por violação
            dos Termos de Uso. Caso a sua inscrição e contratação dos Serviços
            sejam rescindidas, nenhum pagamento, mensalidade, taxa ou despesa
            será reembolsável.
          </p>
          <p>
            <strong>12. Propriedade Intelectual</strong>
          </p>
          <p>
            12.1 Direitos autorais. O conteúdo publicado no website
            profaprizattera.com.br e outros trabalhos de autoria encontrados na
            Plataforma como parte dos Serviço ("Conteúdo") estão protegidos
            pelas leis e tratados de direitos autorais nacionais e
            internacionais, assim como outras leis e tratados de propriedade
            intelectual. O Conteúdo é licenciado, não vendido. Você não pode
            fazer cópias não autorizadas ou usar nenhum Conteúdo, exceto como
            especificado aqui e de acordo com as leis aplicáveis. Todos os
            direitos autorais do Conteúdo e dos Serviços (incluindo, mas não se
            limitando a imagens, fotografias, animações, vídeos, áudio, música,
            texto, layout e “look and feel” incorporados nos Serviços) são de
            propriedade do profaprizattera.com.br. Você concorda em cumprir com
            todas as leis de proteção dos direitos autorais relacionadas ao uso
            dos Serviços e do Conteúdo. O profaprizattera.com.br reserva-se o
            direito de tomar as medidas que julgar apropriadas, a seu exclusivo
            critério, a fim de proteger os direitos autorais do Conteúdo e dos
            Serviços, além das condições previstas nestes Termos de Uso.
          </p>
          <p>
            12.3 Não é permitido aos Usuários e Membros tentar reconfigurar,
            desmontar ou fazer engenharia reversa no website, nos Serviços e/ou
            no Conteúdo do profaprizattera.com.br.
          </p>
          <p>
            12.4 Marcas. Você não está autorizado a utilizar nenhum marca e/ou
            sinais distintivos encontrados no website, no Conteúdo e/ou nos
            Serviços do profaprizattera.com.br. Você não pode copiar, exibir ou
            usar nenhuma das marcas comerciais sem consentimento prévio por
            escrito do seu proprietário. Qualquer uso não autorizado poderá
            violar as leis de propriedade industrial, leis de privacidade, de
            propriedade intelectual e ainda estatutos civis e/ou criminais.
          </p>
          <p>
            12.5 Todos os direitos e licenças não concedidos expressamente
            nestes Termos de Uso são reservados aos proprietários dos Conteúdos
            e/ou Serviços. Estes Termos de Uso não concedem quaisquer licenças
            implícitas.
          </p>
          <p>
            <strong>13. Proibição de Revenda</strong>
          </p>
          <p>
            13.1 Você concorda em não reproduzir, duplicar, copiar, vender,
            revender ou explorar com quaisquer fins comerciais, qualquer porção
            da Plataforma profaprizattera.com.br nem fazer uso da Plataforma ou
            do acesso está para o fim de vendas de bens ou serviços, ou a
            promoção de uma companhia, bem ou serviço.
          </p>
          <p>
            <strong>14. Disposições Gerais</strong>
          </p>
          <p>
            14.1. Estes Termos de Uso, juntamente com a Política de Privacidade
            publicada no nosso website, constituem o acordo integral entre as
            Partes com relação ao objeto em questão, e substituem todos os
            acordos anteriores, escritos ou verbais. 14.2. As Partes são
            contratantes independentes, não resultando este instrumento na
            criação de qualquer sociedade, franquia, representação de vendas ou
            relações que não as expressamente previstas nestes Termos de Uso.
          </p>
          <p>
            14.3. Caso qualquer uma das cláusulas e condições destes Termos de
            Uso venha a ser declarada nula, no todo ou em parte, por qualquer
            motivo legal ou contratual, as demais cláusulas continuarão em pleno
            vigor e efeito.
          </p>
          <p>
            14.4 A tolerância ou o não exercício, por qualquer das Partes, de
            quaisquer direitos a ela assegurados nestes Termos de Uso ou na lei
            em geral não importará em novação ou em renúncia a qualquer desses
            direitos, podendo a referida Parte exercê-los durante a vigência
            destes Termos de Uso.
          </p>
          <p>
            14.4 Notificações, avisos ou comunicações relativas aos presentes
            Termos de Uso serão enviados por escrito, por meio de carta
            protocolada ou com aviso de recebimento, fac-símile ou
            correspondência eletrônica com comprovação de recebimento, por
            qualquer uma das Partes à outra.
          </p>
          <p>
            14.5 Fica eleito o foro da Comarca da Capital do Estado do Pará, com
            exclusão de qualquer outro, por mais privilegiado que seja, para
            dirimir quaisquer litígios ou controvérsias oriundos dos presentes
            Termos de Uso.
          </p>
          <p>Equipe Profa. Pri Záttera</p>
          <p>
            - Políticas de cancelamento e arrependimento (7 dias de acordo com o
            CDC): prazo, contato, política de ressarcimento do serviço
          </p>
          <p>
            Em até&nbsp;7 (sete) dias após a compra&nbsp;do plano de serviços,
            em caso de desistência da contratação, você pode solicitar o
            cancelamento. Neste caso, o&nbsp;reembolso será realizado pela
            Professora Pri Záttera&nbsp;por meio de estorno no cartão de crédito
            no qual a compra foi efetuada,&nbsp;realizado&nbsp;em até 60
            (sessenta) dias após a solicitação.
          </p>
          <p>
            Nenhum pagamento será reembolsável quando solicitado após 7 (sete)
            dias da data de compra do plano de serviços.&nbsp;
          </p>
          <p>
            No caso de pagamentos via boleto bancário, os reembolsos serão
            realizados por meio de depósito em conta corrente do contratante
            dentro do prazo de 60 (sessenta) dias após a solicitação.
          </p>
          <p>
            Quanto ao cancelamento de planos de correção de redação: O aluno
            poderá cancelar o plano de correção de redação (desde que
            respeitando o prazo de até 7 (sete dias) do CDC); entretanto, caso o
            aluno tenha recebido alguma redação corrigida, será descontado o
            valor unitário da correção no estorno. Por esse motivo, a devolução
            do pagamento ocorrerá apenas via depósito em conta corrente do
            contratante, tendo em vista que haverá abatimento do custo.{" "}
          </p>
          <p>
            <strong>&nbsp;</strong>
          </p>
          <p>
            <strong>Equipe PROFAPRIZATTERA.com.br - Redação</strong>
          </p>
          <p>
            <strong>Email: contatoprofapri@gmail.com</strong>
          </p>
          <button onClick={() => setIsModalOpen(false)}>Fechar</button>
        </Modal>
        <div className={`footer__area ${gray_bg ? "grey-bg-2" : "footer-bg"}`}>
          <div className={`footer__top ${pt} pb-40`}>
            <div className="container">
              <div className="row">
                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6">
                  <div className="footer__widget mb-50">
                    <div className="footer__widget-head mb-22">
                      <div className="footer__logo">
                        <Link to="/">
                          <img
                            src={
                              gray_bg
                                ? "/assets/img/logo/logo-pri-footer.png"
                                : "/assets/img/logo/logo-pri-footer.png"
                            }
                            alt=""
                          />
                        </Link>
                      </div>
                    </div>
                    <div
                      className={`footer__widget-body ${gray_bg ? "footer__widget-body-2" : ""}`}
                    >
                      <p>
                        É hora de começar a investir em você mesmo. Porque
                        aprender Redação pode ser a maneira mais fácil de mudar
                        seu futuro.
                      </p>
                      <div className="footer__social">
                        <ul>
                          <li key="social_instagram">
                            <a
                              href="https://www.instagram.com/profaprizattera/"
                              target="_blank"
                            >
                              <i className="social_instagram"></i>
                            </a>
                          </li>

                          <li key="social_youtube">
                            <a
                              href="https://www.youtube.com/c/ProfaPriZ%C3%A1ttera"
                              target="_blank"
                            >
                              <i className="social_youtube"></i>
                            </a>
                          </li>

                          <li key="icon_chat_alt">
                            <a
                              href="https://wa.me/554999738151"
                              target="_blank"
                            >
                              <i className="icon_chat_alt"></i>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                {footer_widget.map((widget, index) => (
                  <div key={index} className={widget.col}>
                    <div className="footer__widget mb-50">
                      <div className="footer__widget-head mb-22">
                        <h3
                          className={`footer__widget-title ${gray_bg ? "footer__widget-title-2" : ""}`}
                        >
                          {widget.title}
                        </h3>
                      </div>
                      <div className="footer__widget-body">
                        <div
                          className={`footer__link ${gray_bg ? "footer__link-2" : ""}`}
                        >
                          <ul>
                            {widget.footer__link.map((link, index) => (
                              <li key={index}>
                                {link == "Principal" ? (
                                  <Link to="/">{link}</Link>
                                ) : (
                                  ""
                                )}
                                {link == "Cursos" ? (
                                  <Link to="/cursos">{link}</Link>
                                ) : (
                                  ""
                                )}
                                {link == "Conheça a Pri" ? (
                                  <Link to="/#pri">{link}</Link>
                                ) : (
                                  ""
                                )}
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
                <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-5 col-sm-6">
                  <div className="footer__widget footer__pl-70 mb-50">
                    <div className="footer__widget-head mb-22">
                      <h3
                        className={`footer__widget-title ${gray_bg ? "footer__widget-title-2" : ""}`}
                      >
                        Newsletter
                      </h3>
                    </div>
                    <div className="footer__widget-body">
                      <div
                        className={`footer__subscribe ${gray_bg ? "footer__subscribe-2" : ""}`}
                      >
                        <form onSubmit={handleSubmit}>
                          <div className="footer__subscribe-input mb-15">
                            <input
                              type="text"
                              value={values.email}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              placeholder="Digite seu e-mail"
                              name="email"
                            />

                            <button type="submit">
                              <i className="far fa-arrow-right"></i>
                              <i className="far fa-arrow-right"></i>
                            </button>
                          </div>
                          {touched.email && <ErrorMsg error={errors.email} />}

                          {apiErrors && <ErrorApiMsg error={apiErrors} />}

                          {apiSuccess && <SuccessApiMsg msg={apiSuccess} />}
                        </form>
                        <p>
                          Receba as últimas novidades e descontos especiais no
                          e-mail.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className={`footer__bottom ${gray_bg ? "footer__bottom-2" : ""}`}
          >
            <div className="container">
              <div className="row">
                <div className="col-xxl-12">
                  <div
                    className={`footer__copyright ${gray_bg ? "footer__copyright-2" : ""} text-center`}
                  >
                    <p>
                      © {new Date().getFullYear()} Pri Zattera. Todos os
                      direitos reservados.{" "}
                      <a onClick={() => setIsModalOpen(true)}>
                        Política de privacidade
                      </a>{" "}
                      e os Termos de Uso. CNPJ: 32.248.612/0001-94
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
